import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(private http: HttpService) {}

  getConfig(): Observable<any> {
    return this.http.get<any>('core/get-config/');
  }

  viaCep(cep: any): Observable<any> {
    return this.http.get<any>('https://viacep.com.br/ws/' + cep + '/json/');
  }
}
